import { useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import { Vendor } from "../types";
import { setVendors } from "../features/appSlice";

export const useVendors = () => {
  const dispatch = useAppDispatch();
  const vendors = useAppSelector((state) => state.app.vendors);

  const [filterCity, setFilterCity] = useState<string>("");
  const [filterType, setFilterType] = useState<string>("");
  const [sortField, setSortField] = useState<keyof Vendor | null>(null);
  const [sortAsc, setSortAsc] = useState(true);

  const sortedFilteredVendors = useMemo(() => {
    return vendors
      .filter((v) => {
        if (!filterCity) return true;
        return v.located?.toLowerCase() === filterCity.toLowerCase();
      })
      .filter((v) => {
        if (!filterType) return true;
        return String(v.type?.id ?? "") === filterType;
      })
      .sort((a, b) => {
        if (!sortField) return 0;
        let valA: any = a[sortField];
        let valB: any = b[sortField];
        if (sortField === "type") {
          valA = a.type?.name ?? "";
          valB = b.type?.name ?? "";
        }
        if (typeof valA === "number" && typeof valB === "number") {
          return sortAsc ? valA - valB : valB - valA;
        }
        return sortAsc
          ? String(valA || "").localeCompare(String(valB || ""))
          : String(valB || "").localeCompare(String(valA || ""));
      });
  }, [vendors, filterCity, filterType, sortField, sortAsc]);

  const setVendorList = (newVendors: Vendor[]) =>
    dispatch(setVendors(newVendors));

  return {
    vendors,
    sortedFilteredVendors,
    filterCity,
    filterType,
    setFilterCity,
    setFilterType,
    sortField,
    setSortField,
    sortAsc,
    setSortAsc,
    setVendors: setVendorList,
  };
};
